//#region imports
import React, { Component } from 'react';
import {
    Polyline, InfoWindow,
    GoogleMap, Marker, withScriptjs, withGoogleMap, StreetViewPanorama, KmlLayer
} from 'react-google-maps';
import MainMenu from '../main-menu';
import cm from '../connection-manager';
import MapLibrary from './map-lib';
import config from '../config';
import { Label, Icon, List } from 'semantic-ui-react';
import { CollapsibleListFactory, Menu, MenuItem } from "@blueprintjs/core";
// css
import 'semantic-ui-css/semantic.min.css';
import '../index.css';
import $ from 'jquery';
// images from: http://www.iconarchive.com/show/vista-map-markers-icons-by-icons-land.html
import endIconImg from '../images/Map-Marker-Ball-Pink.png';
import { latLng, marker, tooltip } from 'leaflet';

//#endregion
//#region setup
const { compose } = require("recompose");
const { MarkerWithLabel } = require("react-google-maps/lib/components/addons/MarkerWithLabel");

function getToken() {
    const tokenString = JSON.parse(sessionStorage.getItem('token'));
    return tokenString
}

// Getting all the static functions from map library
const {
    DefaultViewport,
    PlotStates,
    decodeRouteData,
    decodeDetailedRouteData,
    distance,
    createPolyLine,
    createPolyLineStd,
    convertToRouteString,
    convertToRouteLatLngArray,
    convertArrayToLatLng,
    convertLatLngToArray,
    gBoundedPadding //needs more adjustments in this.
} = MapLibrary;

const defaultMapProps = {
    zoom: 17,
    key: 'AIzaSyBKU0d8AX_EkRBshNBfw1V5jL63PoUop9o'
};

const startIcon = 'https://dotsc.ugpti.ndsu.nodak.edu/grit/images/Map-Marker-Ball-Chartreuse.png';
const endIcon = 'https://dotsc.ugpti.ndsu.nodak.edu/AssetManagement_Files/Images/map_icons/Centered/32x32/MapMarker_Ball__Red.png';//<div className='customIconRed' style={{ width: 32, height: 32 }}></div>;
const singlePointIcon = 'https://dotsc.ugpti.ndsu.nodak.edu/AssetManagement_Files/Images/map_icons/Centered/32x32/MapMarker_Ball__Black.png';



// switch signs lol
const waypointIcon = 'https://dotsc.ugpti.ndsu.nodak.edu/grit/images/location_pin.png';

const startIconSpecial = 'https://dotsc.ugpti.ndsu.nodak.edu/AssetManagement_Files/Images/map_icons/Centered/32x32/MapMarker_Ball__Orange.png';
const startIconPreload = 'https://dotsc.ugpti.ndsu.nodak.edu/grit/images/Map-Marker-Ball-Azure.png';

// Initial markers: for testing purposes
/*const initMarkers = [
    {
        key: 0, Id: 1000, position: { lat: 46.896, lng: -96.803 }, value: "test marker 1",
        icon: startIcon
    },
    {
        key: 1, Id: 1001, position: { lat: 46.896, lng: -96.806 }, value: "test marker 1",
        icon: endIcon
    }
];*/

function googleMapsCreateBounds(latlngArray) {

    var bounds = new window.google.maps.LatLngBounds();
    for (var p of latlngArray) {
        bounds.extend(p);
    }

    return bounds;
}

function convertMapCenter(centerFunc) {
    return { lat: centerFunc.lat(), lng: centerFunc.lng(), };
}

let oms = null;
let streetRef = null;
//#endregion
//#region creating wrapped map
const WrappedMap = compose(withScriptjs, withGoogleMap)(props =>
    <GoogleMap
        defaultCenter={defaultMapProps.center}
        defaultZoom={defaultMapProps.zoom}

        onMapInitialized={props.onMapInitialized}

        defaultOptions={{

            streetViewControl: true,
            scaleControl: true,
            mapTypeControl: true,
            mapTypeControlOptions: {
                style: window.google.maps.MapTypeControlStyle.HORIZONTAL_BAR,
                mapTypeIds: ['roadmap', 'terrain', 'satellite'],
                position: window.google.maps.ControlPosition.BOTTOM_RIGHT
            },

        }}

        ref={props.refMap}>

        {/***** Display markers ****/}

        {props.backgroundPolyLineRender}
        {props.backgroundMarkersRender}

        {props.endMarkers}
        {props.startMarkers}
        {props.tempMarkers}
        {props.tempPreviewMarkers}
        {props.waypoints}

        {/* Detour Variables */}
        {props.DetourPolyLine}
        {props.DetourStart}
        {props.DetourEnd}
        {props.detourTempMarkers}
        {props.detourWaypoints}

        {props.selectedRoute}
        {props.previewPolyLine}

        {props.tempMarkerRed}
        {props.tempGreenMarker}

        {props.measureTools}

        {props.locationMarker}

        {props.specialLayer}

        <StreetViewPanorama defaultOptions={{
            addressControlOptions: {
                position: window.google.maps.ControlPosition.BOTTOM_CENTER
            }
        }}

            ref={(m) => {
                streetRef = m;
            }}

            onPositionChanged={(e) => {
                if (streetRef && streetRef.context && streetRef.context.__SECRET_MAP_DO_NOT_USE_OR_YOU_WILL_BE_FIRED && streetRef.context.__SECRET_MAP_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.streetView) {
                    let lat = streetRef.context.__SECRET_MAP_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.streetView.position.lat() || 0;
                    let lng = streetRef.context.__SECRET_MAP_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.streetView.position.lng() || 0;
                    let heading = streetRef.context.__SECRET_MAP_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.streetView.pov.heading || 0;
                    let pitch = streetRef.context.__SECRET_MAP_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.streetView.pov.pitch || 0;
                    let zoom = streetRef.context.__SECRET_MAP_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.streetView.zoom || 0;
                    let fov = (180 / Math.pow(2, zoom)) - 4;
                    let urlImage = `https://maps.googleapis.com/maps/api/streetview?size=2048x2048&location=${lat},${lng}&fov=${fov}&heading=${heading}&pitch=${pitch}&key=AIzaSyBKU0d8AX_EkRBshNBfw1V5jL63PoUop9o`;

                    sessionStorage.setItem('streetViewMapUrl', urlImage);
                }
            }}

            onPovChanged={(e) => {
                if (streetRef && streetRef.context && streetRef.context.__SECRET_MAP_DO_NOT_USE_OR_YOU_WILL_BE_FIRED && streetRef.context.__SECRET_MAP_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.streetView) {
                    let lat = streetRef.context.__SECRET_MAP_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.streetView.position.lat() || 0;
                    let lng = streetRef.context.__SECRET_MAP_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.streetView.position.lng() || 0;
                    let heading = streetRef.context.__SECRET_MAP_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.streetView.pov.heading || 0;
                    let pitch = streetRef.context.__SECRET_MAP_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.streetView.pov.pitch || 0;
                    let zoom = streetRef.context.__SECRET_MAP_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.streetView.zoom || 0;
                    let fov = (180 / Math.pow(2, zoom)) - 4;
                    let urlImage = `https://maps.googleapis.com/maps/api/streetview?size=2048x2048&location=${lat},${lng}&fov=${fov}&heading=${heading}&pitch=${pitch}&key=AIzaSyBKU0d8AX_EkRBshNBfw1V5jL63PoUop9o`;

                    sessionStorage.setItem('streetViewMapUrl', urlImage);
                }
            }}

            onZoomChanged={(e) => {
                if (streetRef && streetRef.context && streetRef.context.__SECRET_MAP_DO_NOT_USE_OR_YOU_WILL_BE_FIRED && streetRef.context.__SECRET_MAP_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.streetView) {
                    let lat = streetRef.context.__SECRET_MAP_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.streetView.position.lat() || 0;
                    let lng = streetRef.context.__SECRET_MAP_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.streetView.position.lng() || 0;
                    let heading = streetRef.context.__SECRET_MAP_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.streetView.pov.heading || 0;
                    let pitch = streetRef.context.__SECRET_MAP_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.streetView.pov.pitch || 0;
                    let zoom = streetRef.context.__SECRET_MAP_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.streetView.zoom || 0;
                    let fov = (180 / Math.pow(2, zoom)) - 4;
                    let urlImage = `https://maps.googleapis.com/maps/api/streetview?size=2048x2048&location=${lat},${lng}&fov=${fov}&heading=${heading}&pitch=${pitch}&key=AIzaSyBKU0d8AX_EkRBshNBfw1V5jL63PoUop9o`;

                    sessionStorage.setItem('streetViewMapUrl', urlImage);
                }
            }}
        />

        <KmlLayer
            url="https://dotsc.ugpti.ndsu.nodak.edu/AssetManagement_Files/Boundary.kmz"
            options={{
                suppressInfoWindows: true,
                clickable: false,
                preserveViewport: true
            }}
        />
        <KmlLayer
            url="https://dotsc.ugpti.ndsu.nodak.edu/AssetManagement_Files/mn_county_bnd.kmz"
            options={{
                suppressInfoWindows: true,
                clickable: false,
                preserveViewport: true
            }}
        />
        <KmlLayer
            url="https://dotsc.ugpti.ndsu.nodak.edu/AssetManagement_Files/SD_Gray.kmz"
            options={{
                suppressInfoWindows: true,
                clickable: false,
                preserveViewport: true
            }}
        />
    </GoogleMap>
);
//#endregion

export default class Main extends Component {

    async componentDidMount() {
        // this.getDetour()

    }

    constructor(props) {
        super(props);

        this.locationMarkerRef = null;

        //State initialization.
        this.state = {
            showSnap: false,
            showEndMarkers: false,
            viewport: DefaultViewport,
            showCrosshair: false,
            showSelect: false,
            shouldHide: 0,
            markers: [],//initMarkers
            childMarkers: [],
            tempMarkers: [],
            endMarkers: [],
            waypointMarkers: [],

            // TODO: move complitcated Current Route Logic to this in the future.
            selectedMarker: null,

            selectedRoute: true,
            polylines: [],
            detailsPolylines: [],
            isCheckOverlap: false,
            overlapingId: 0,
            overlapDistance: 0,

            previewMarker: [],
            previewPolyline: [],

            /* Detour State Variables */
            DetourPolyLine: [],
            DetourStart: null,
            DetourEnd: null,
            detourTempMarkers: [],
            detourTabSelected: 0,
            detourWaypointMarkers: [],



            tempGreenMarker: null,
            tempRedMarker: null,
            AgencyData: [],
            showMeasureTool: false,
            prevMarker: null,
            specialLayerOn: false,
            specialLayer: null,
            animateMarker: 0,
            popupMarker: 0,
            distance: 0 + ' ft.',
            hasBeenTouched: false,

            measureLocation1: { lat: 46.897753, lng: -96.802437 },
            measureLocation2: { lat: 46.897753, lng: -96.802437 },
            measureToolSelected: 0,
            shouldHideCPLegend: false,//this is to hide construction planning legend
            backgroundPolyLines: [],
            backgroundMinorStructureMarkers: [],
            showLocationMarker: false,
            currentLayer: 'none',
            dateManagerComp: false,
            stockManagerComp: false,

            VRICPhotos: undefined,

            /* detour route in construction planning variables */
            detour: [],
            selectedRouteId: null,

            /* Sign Layer available panels */
            availablePanels: [],
            lastSelectedPoint: null,
            showsignLegend: false,
            streetViewMapUrl: ''
        }

        this.googleMapsContainer = null;
        this.menuControls = null;
        this.map = null;
        this.mapRef = null;
        this.plotMode = PlotStates.none;
        this.onBackgroundLayerChange = null;
        //create new connection, add io methods into constructor
        this.ioc = cm.getIoc();

        this.detourPath = null
        this.detourCurrentRoute = {
            detourStartPoint: null,
            detourRouteLine: null,
            detourEndPoint: null,
            detourWayPoint: []
        }
        this.startDetourCallback = null;
        this.endDetourCallback = null;
        this.currentDetourWaypointId = -1;


        this.currentRoute = {
            startPoint: null,
            routeLine: null,
            endPoint: null,
            waypoint: []
        };

        this.startCallback = null;
        this.endCallback = null;

        this.currentWaypointId = -1;

        this.tempPolyLine = null;
        this.tempGreenMarker = null;

        this.isLocationPointMode = false;

        // this is a function
        this.triggerPolylineSwitch = null;
        this.onToggleSpecialLayer = null;
        this.measureDistance = 'Select and drag to measure.';

    }

    //#region helper setup 
    // viewport is the size of the screen, so it updates when it changes
    onViewportChanged = (viewport) => {
        this.setState({ viewport });
    }
    hideCrossHair = () => {
        this.setState({ showCrosshair: false, showSnap: false, showEndMarkers: false });
        this.plotMode = PlotStates.none;
    }
    // custom map stuff
    createMapOptions(maps) {
        return {
            mapTypeControl: true,
            mapTypeControlOptions: {
                style: window.google.maps.MapTypeControlStyle.DROPDOWN_MENU,
                mapTypeIds: ['roadmap', 'terrain', 'satillite'],
                position: window.google.maps.ControlPosition.TOP_CENTER
            },
            streetViewControl: false
        }
    }
    //#endregion

    /**
     * Main Render function that contains render map.
     */
    render() {

        //Click functions are important for callback events from the ui, button presses that change map state happens here.
        const clickFunctions = {
            onClickDetourStart: (callbackGetPos, setCoordManual = null) => {
                let pos = setCoordManual ? setCoordManual : convertMapCenter(this.map.getCenter());

                if (setCoordManual) {
                    this.plotMode = PlotStates.startpoint;
                }
                this.setState({ detourTabSelected: 4 })

                this.startDetourCallback = callbackGetPos;
                this.onClickDetourStart(pos);

            },
            onClickDetourEnd: (callbackGetPos, setCoordManual = null) => {
                let pos = setCoordManual ? setCoordManual : convertMapCenter(this.map.getCenter());

                if (setCoordManual) {
                    this.plotMode = PlotStates.endpoint;
                }
                this.setState({ detourTabSelected: 4 })
                this.endDetourCallback = callbackGetPos;
                this.onClickDetourEnd(pos);

            },
            onDetourWaypointPlot: (callbackGetPos, id) => {
                let pos = convertMapCenter(this.map.getCenter());
                this.setState({ detourTabSelected: 4 })
                this.onDetourWaypointPlot(pos, id);

                // do we need a callback?
                this.startDetourCallback = callbackGetPos;
            },

            // normal route funtions
            onClickStart: (callbackGetPos, setCoordManual = null) => {
                let pos = setCoordManual ? setCoordManual : convertMapCenter(this.map.getCenter());

                if (setCoordManual) {
                    this.plotMode = PlotStates.startpoint;
                }

                this.startCallback = callbackGetPos;
                this.onClickStart(pos);
            },
            onClickEnd: (callbackGetPos, setCoordManual = null) => {
                let pos = setCoordManual ? setCoordManual : convertMapCenter(this.map.getCenter());

                if (setCoordManual) {
                    this.plotMode = PlotStates.endpoint;
                }

                this.endCallback = callbackGetPos;
                this.onClickEnd(pos);

            },

            // point based function.
            onClickSinglePoint: (callbackGetPos, setCoordManual = null) => {

                let pos = setCoordManual ? setCoordManual : convertMapCenter(this.map.getCenter());

                if (setCoordManual) {
                    this.plotMode = PlotStates.singlepoint;
                }

                this.startCallback = callbackGetPos;
                this.onClickSinglePoint(pos);
            },



            onClickInletPoint: (callbackGetPos, setCoordManual = null) => {
                let pos = setCoordManual ? setCoordManual : convertMapCenter(this.map.getCenter());

                if (setCoordManual) {
                    this.plotMode = PlotStates.startpoint;
                }

                this.startCallback = callbackGetPos;
                this.onClickStart(pos, null, true); // note: snapped callback maybe deprecated since "spiderfyer"
            },
            onClickOutletPoint: (callbackGetPos, setCoordManual = null) => {
                let pos = setCoordManual ? setCoordManual : convertMapCenter(this.map.getCenter());

                if (setCoordManual) {
                    this.plotMode = PlotStates.endpoint;
                }

                this.endCallback = callbackGetPos;
                this.onClickEnd(pos, true);
            },

            // Waypoint plotting
            onWaypointPlot: (callbackGetPos, id) => {
                let pos = convertMapCenter(this.map.getCenter());

                this.onWaypointPlot(pos, id);

                // do we need a callback?
                this.startCallback = callbackGetPos;
            },
            onWaypointSplice: (id) => {
                this.onWaypointSplice(id);
            },
            onSubmittedMarker: (route) => {
                if (route)
                    this.clearStartWhenAddedPoint();
            },

            onCancelEdit: this.onCancelEdit,
            onLayerLoaded: this.onLayerLoaded,
            onHighlight: this.onHighlight,
            onSelect: this.onSelect,
            onClearMap: this.onClearMap,
            onPolyLineTick: (ispoly) => {
                if (this.triggerPolylineSwitch) {
                    this.triggerPolylineSwitch(ispoly);
                }
            },

            updateMSMarker: this.updateMSMarker,

            // background callback, // added layer name to deal with minor structures bkg layer -Elliot 06/03/2021
            onLoadBackgroundLayer: (layerData, layerName = "none") => {
                if (layerName === "StructureAge" || layerName === "StructureMaterial" || layerName === "StructureCondition" || layerName === "StructureType") {
                    for (const p of layerData) {
                        //adding new value called marker point in nice array
                        p.MarkerPoint = convertToRouteLatLngArray(p.Point.points); // points has one point
                    }
                    this.setState({ backgroundPolyLines: [] });
                    this.setState({ backgroundMinorStructureMarkers: layerData });
                } else {
                    for (const p of layerData) {
                        p.points = convertToRouteLatLngArray(p.RouteEvent && p.RouteEvent.points ? p.RouteEvent.points : []);
                    }

                    this.setState({ backgroundMinorStructureMarkers: [] });
                    this.setState({ backgroundPolyLines: layerData });
                }
            },
            showHideMeaureTool: (showState) => {
                if (showState) {
                    const mc = this.map.getCenter();
                    this.showHideMeasureTool(true, { lat: mc.lat(), lng: mc.lng() });
                }
                else {
                    this.showHideMeasureTool(false, { lat: 0, lng: 0 });
                }

            },
            toggleEndMarkers: () => {
                this.setState({
                    showEndMarkers: !this.state.showEndMarkers
                });
            },
            toggleCPLegend: () => {
                this.setState({ shouldHideCPLegend: false });
            },
            constructionHistorySnappingLayer: (data) => { this.constructionHistorySnappingLayer(data) },
            toggleSpecialLayer: (bool) => { this.toggleSpecialLayer(bool) },
            onCheckOverlapping: (start, end) => {
                this.onCheckOverlapping(start, end)
            }
        };
        this.onBackgroundLayerChange = clickFunctions.onLoadBackgroundLayer;
        this.onToggleSpecialLayer = clickFunctions.toggleSpecialLayer;

        //If the user doesn't have a token, redirect to login
        const token = getToken();
        if (token === null || (token.id === "null" || (!token.logged && this.props.isPublic === undefined))) {
            window.open(sessionStorage.getItem('url'), "_self");
            return null
        } else {

            return (<MainMenu
                toggleCrosshair={this.hideCrossHair}
                isPublic={this.props.isPublic}
                VRIC={this.props.VRIC}
                VRICPhotos={this.state.VRICPhotos}
                UpdateVRICPhotos={this.updateVRICPhotoList}
                onLayerChanged={(layer) => { this.setState({ currentLayer: layer, overlapingId: 0, overlapDistance: 0 }) }}
                mapRender={this.renderMap()}
                loadMap={this.loadMap}
                history={this.props.history}
                ref={(m) => { this.menuControls = m; }}
                routeLine={convertLatLngToArray(this.state.polylines)}
                DetourRouteLine={this.state.DetourPolyLine}
                clickFunctions={clickFunctions}
                hideCPLegend={this.state.shouldHideCPLegend}
                ag={this.props.ag}
                dateManagerComp={this.state.dateManagerComp}
                setDateManagerComp={this.setDateManagerComp}
                stockManagerComp={this.state.stockManagerComp}
                setStockManagerComp={this.setStockManagerComp}
                detourTabSelected={this.state.detourTabSelected}
                SignLayerAvailablePanels={this.state.availablePanels}
                showsignLegend={this.state.showsignLegend}
                overlapingId={this.state.overlapingId}
            />);
        }
    }

    /**
     * Render Map function, passed as callback in Menu ui.
     */
    renderMap() {
        const tempMarkers = this.state.tempMarkers.map(this.mapTempMarkers);
        const tempPreviewMarkers = this.state.previewMarker.map(this.mapTempMarkers);

        //Detour temp Marker
        const detourTempMarkers = this.state.detourTempMarkers.map(this.mapdetourTempMarkers)

        // creates a popup on a marker.
        const mobilePointSelecter = (marker, layerId) => {
            return (
                <InfoWindow autoPan={false} position={marker.position} >
                    <div>
                        <span>Click to Select</span>
                        <Menu> {/*If not in edit mode this will create a new point for you.*/}
                            <MenuItem iconName="pt-icon-select" style={{ border: '1px' }} text="Select" onClick={() => {
                                console.log('clicked')
                                this.menuControls.selectMarker(marker.Id, marker, layerId);
                                this.menuControls.setState({ menuVisible: true, showData: true });
                                this.setState({ hasBeenTouched: false });
                            }} />
                        </Menu>
                    </div>
                </InfoWindow>
            )
        };

        // creates a tooltip on a marker.
        const tooltipPointSelecter = (marker) => {
            return (
                <InfoWindow autoPan={false} position={marker.position} >
                    <div>
                        <div style={{ marginTop: -3, marginBottom: -3 }}>{marker.Id}</div>
                    </div>
                </InfoWindow>
            )
        };

        // creates a overlap on a marker.
        const overlapPointSelecter = (marker, distance) => {
            return (
                <InfoWindow autoPan={false} position={marker.position}>
                    <div>
                        <div style={{ marginTop: -3, marginBottom: -3, color: 'red' }}>Overlap {distance} FT.</div>
                    </div>
                </InfoWindow>
            )
        };

        // creates a tooltip on a NDTownshipProjectNumber.
        const tooltipNDTownshipProjectNumber = (marker) => {
            let item = this.state.backgroundPolyLines.find(x => x.RouteId == marker.Id);
            if (item && item.ProjectNumber)
                return (
                    <InfoWindow autoPan={false} position={marker.position} >
                        <div>
                            <div style={{ marginTop: -3, marginBottom: -3 }}>{item.ProjectNumber}</div>
                        </div>
                    </InfoWindow>
                )
        };

        // key here should be actual marker Id
        const startMarkers = this.state.markers.map((marker) => {
            let { key, Id, position, icon, layerId, PrHigh } = marker;

            // Check for preloaded routes, don't check on locationPoints
            if (marker.layerId !== 3) {
                if (marker.pointData.route && marker.pointData.route.routeLength === 0) {
                    icon = startIconPreload;
                }
            }

            let size = { width: 32, height: 32 };
            if (this.state.animateMarker === Id && this.state.popupMarker === 0) { size = { width: 40, height: 40 } };

            return <Marker key={key} position={position}
                zIndex={100}
                icon={{ url: icon, scaledSize: size }}
                label={layerId == 6 && PrHigh ? { text: 'HP', color: '#FF00FF', fontWeight: 'bold' } : null}
                // title='High Priority'
                onMouseOver={(e) => {
                    if (!this.state.showSnap) {
                        this.onHighlight(marker, true);
                    }
                    else {
                        this.setState({ popupMarker: Id });
                    }
                    if (this.state.animateMarker !== Id) {
                        //console.log(this.state.animateMarker);
                        this.setState({ animateMarker: Id });
                    }
                }}

                onMarkerInitialized={(markRef) => {
                    if (oms !== null) {
                        oms.addMarker(markRef);

                        markRef.SpecialClick = () => {
                            if (!this.state.showSnap) {
                                this.menuControls.selectMarker(Id, marker, layerId);
                            }
                        }
                    }
                }}

                onMouseOut={() => {
                    this.onHighlight(marker, false);
                    this.setState({ animateMarker: 0 });
                }}

                onClick={() => {
                    this.setState({ overlapingId: 0, overlapDistance: 0 })
                    // todo move to spidifier (not sure if done or not yet- Elliot 06/08/2021)
                    if (!this.state.showSnap) {

                        if (window.mobileAndTabletcheck()) {
                            if (this.state.prevMarker == null) {
                                //this.setState({ hasBeenTouched: true });
                            }
                            else {
                                this.onHighlight(this.state.prevMarker, false);
                            }
                            this.onHighlight(marker, true);
                            this.setState({ prevMarker: marker });

                            if (this.state.animateMarker !== marker.Id) {
                                this.setState({ animateMarker: marker.Id });
                            }
                            this.setState({ hasBeenTouched: true });
                        }
                    }
                    else {
                        if (window.mobileAndTabletcheck()) {
                            this.setState({ popupMarker: Id });
                        }
                    }
                }}
                //not sure what the ref here does but was getting undef. error on markerRef
                ref={(m) => {
                    if (m) {
                        /*do something with that ref*/
                        //console.log("you're at 'markerRef' in start markers");
                        //markerRef = m;
                    }
                }}>
                <div>
                    {this.state.showSnap && (this.state.popupMarker === Id) && this.popupSnapper(marker)}
                    {this.state.hasBeenTouched && (this.state.animateMarker === Id) && !this.state.showSnap && mobilePointSelecter(marker, layerId)}
                    {config.enableTooltip && !window.mobileAndTabletcheck() && tooltipPointSelecter(marker)}
                    {this.state.overlapingId > 0 && !window.mobileAndTabletcheck() && (this.state.overlapingId == marker.Id) && overlapPointSelecter(marker, this.state.overlapDistance)}
                    {!window.mobileAndTabletcheck() && this.state.backgroundPolyLines.length > 0 && this.state.backgroundPolyLines[0]['IsTownship'] && tooltipNDTownshipProjectNumber(marker)}
                </div>
            </Marker>;
        });

        // this is for end marker stuff.
        const endMarkers = this.state.endMarkers.map((marker) => {
            const { key, Id, position, icon, layerId } = marker;

            let size = { width: 32, height: 32 };
            if (this.state.animateMarker === -Id && this.state.popupMarker === 0) { size = { width: 48, height: 48 } };

            return <Marker key={key} position={position} className="grow"
                zIndex={100}
                icon={{ url: icon, scaledSize: size }}
                onMouseOver={(e) => {
                    if (!this.state.showSnap) {
                        this.onHighlight(marker, true);
                    }
                    else {
                        this.setState({ popupMarker: Id });
                    }

                    if (this.state.animateMarker !== -Id) {
                        this.setState({ animateMarker: -Id, popupMarker: -Id });
                    }
                }}

                onMouseOut={() => {
                    this.setState({ animateMarker: 0 });
                }}

                onClick={() => {
                    // todo move to spidifier
                    if (!this.state.showSnap) {
                        this.menuControls.selectMarker(Id, marker, layerId);
                    }
                    else {
                        if (window.mobileAndTabletcheck()) {
                            this.setState({ popupMarker: -Id });
                        }
                    }
                }}

                onReady={(a, b) => { console.log('wap wap wap'); console.log(a); console.log(b); }}
                ref={(m) => { if (m) { /*markerPopup = m.leafletElement;*/ } }} >
                <div>
                    {this.state.showSnap && (this.state.popupMarker === -Id) && this.popupSnapper(marker)}
                </div>
            </Marker>;
        });

        const backgroundPolyLineRender = this.state.backgroundPolyLines.map((lineData) => {
            const pathMap = convertArrayToLatLng(lineData.points);
            return (
                <Polyline path={pathMap} key={lineData.RouteId + lineData.Color} //key here has color to distinguish it from the marker key (also routeid)
                    options={{
                        strokeColor: lineData.Color,
                        strokeOpacity: 0.7,
                        strokeWeight: 5
                    }} />
            )
        });

        //instead of poly line do marker in the case that its minor strucutres
        const backgroundMarkersRender = this.state.backgroundMinorStructureMarkers.map((pointData) => {
            const latlngPoint = { lat: parseFloat(pointData.Point.points[0].x), lng: parseFloat(pointData.Point.points[0].y) };
            // this function draws a custom symbol similar to the google marker
            function pinSymbol(color) {
                return {
                    // alt path: 'M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z',
                    path: 'M 0,0 C -2,-20 -10,-22 -10,-30 A 10,10 0 1,1 10,-30 C 10,-22 2,-20 0,0 z M -2,-30 a 2,2 0 1,1 4,0 2,2 0 1,1 -4,0',
                    fillColor: color,
                    fillOpacity: 1,
                    strokeColor: '#000',
                    strokeWeight: 2,
                    scale: 0.75,
                };
            }
            // these markers are lightweight because they are simply displayed
            return (<Marker key={pointData.LocId}
                position={latlngPoint}
                icon={pinSymbol(pointData.Color)}
                clickable={false}
            />)
        });

        const previewPathMap = this.state.previewPolyline.length > 0 ? convertArrayToLatLng(this.state.previewPolyline) : [];

        this.detourPath = this.state.DetourPolyLine.length > 0 ? convertArrayToLatLng(this.state.DetourPolyLine) : []
        //console.log(this.state.DetourPolyLine)
        const waypointMarkers = this.state.waypointMarkers.map((marker) => {
            const { key, position } = marker;
            return (
                <MarkerWithLabel
                    zIndex={50}
                    position={position}
                    labelAnchor={new window.google.maps.Point(14, 64)}
                    icon={{ url: waypointIcon }}
                    key={key}>
                    <Label color='yellow'>
                        {key}
                    </Label>
                </MarkerWithLabel>)
        });

        const detourWaypointMarkers = this.state.detourWaypointMarkers.map((marker) => {
            const { key, position } = marker;
            return (
                <MarkerWithLabel
                    zIndex={50}
                    position={position}
                    labelAnchor={new window.google.maps.Point(14, 64)}
                    icon={{ url: waypointIcon }}
                    key={key}>
                    <Label color='yellow'>
                        {key}
                    </Label>
                </MarkerWithLabel>)
        });

        // Create Mesuring tools
        const measureTool1 = (
            <MarkerWithLabel position={this.state.measureLocation1}
                draggable
                labelAnchor={new window.google.maps.Point(0, 0)}
                onDrag={(target) => { this.updateMeasureLocation1(target); }}
                zIndex={0}
                onMouseOver={() => {
                    if (this.state.showSnap) {
                        this.setState({ measureToolSelected: 1 });
                    }
                }}>
                <div>
                    <div style={{ minWidth: 150, maxWidth: 500 }}>
                        <Label style={{ opacity: 0.75 }} color='blue' id="distanceLabel">
                            {this.measureDistance}
                            <Label.Detail ><Icon as='a' onClick={() => { this.showHideMeasureTool(false, { lat: 0, lng: 0 }); }} name='delete' corner={true} /></Label.Detail>
                        </Label>
                    </div>
                    {this.state.showSnap && this.state.measureToolSelected === 1 && this.popupSnapper({ position: this.state.measureLocation1 }, { width: 0, height: -40 })}
                </div>
            </MarkerWithLabel>);

        const measureTool2 = (
            <Marker position={this.state.measureLocation2}
                zIndex={0}
                draggable
                onDrag={(target) => { this.updateMeasureLocation2(target); }}
                onMouseOver={() => {
                    if (this.state.showSnap) {
                        this.setState({ measureToolSelected: 2 });
                    }
                }}>
                {this.state.showSnap && this.state.measureToolSelected === 2 && this.popupSnapper({ position: this.state.measureLocation2 })}
            </Marker>
        );

        // final rendering method with all the modules plugged in.
        return (

            <div id="gmap" className="mapStyle">

                <WrappedMap googleMapURL="https://maps.googleapis.com/maps/api/js?key=AIzaSyBKU0d8AX_EkRBshNBfw1V5jL63PoUop9o"
                    loadingElement={<div style={{ height: `100%` }} />}
                    containerElement={<div style={{ height: `100%` }} />}
                    mapElement={<div style={{ height: `100%` }} />}
                    createMapOptions={this.createMapOptions}

                    refMap={(map) => {
                        this.map = map;
                    }}

                    onMapInitialized={(mapProps, map) => {

                        var firstChild = document.createElement('button');
                        firstChild.style.backgroundColor = '#fff';
                        firstChild.style.border = 'none';
                        firstChild.style.outline = 'none';
                        firstChild.style.width = '28px';
                        firstChild.style.height = '28px';
                        firstChild.style.borderRadius = '2px';
                        firstChild.style.boxShadow = '0 1px 4px rgba(0,0,0,0.3)';
                        firstChild.style.cursor = 'pointer';
                        firstChild.style.marginRight = '10px';
                        firstChild.style.padding = '0px';
                        firstChild.title = 'Your Location';

                        var secondChild = document.createElement('div');
                        secondChild.style.margin = '5px';
                        secondChild.style.width = '18px';
                        secondChild.style.height = '18px';
                        secondChild.style.backgroundImage = 'url(https://maps.gstatic.com/tactile/mylocation/mylocation-sprite-1x.png)';
                        secondChild.style.backgroundSize = '180px 18px';
                        secondChild.style.backgroundPosition = '0px 0px';
                        secondChild.style.backgroundRepeat = 'no-repeat';
                        secondChild.id = 'you_location_img';
                        firstChild.appendChild(secondChild);

                        var kmlLayer = new window.google.maps.KmlLayer({
                            url: 'https://dotsc.ugpti.ndsu.nodak.edu/AssetManagement_Files/TWP_Poly_Point_Jo_LayerToKML.kmz',
                            map: mapProps,
                            suppressInfoWindows: true,
                            clickable: false,
                            preserveViewport: true
                        });

                        window.google.maps.event.addListener(mapProps, 'dragend', function () {
                            $('#you_location_img').css('background-position', '0px 0px');
                        });

                        window.google.maps.event.addListener(mapProps, 'zoom_changed', function () {
                            let zoomValue = mapProps.getZoom();
                            if (zoomValue >= 11) {
                                kmlLayer.setMap(mapProps);
                            } else {
                                kmlLayer.setMap(null);
                            }
                        });

                        firstChild.addEventListener('click', () => {
                            this.setState({ showLocationMarker: true });

                            var imgX = '0';
                            var animationInterval = setInterval(function () {
                                if (imgX === '-18') imgX = '0';
                                else imgX = '-18';
                                $('#you_location_img').css('background-position', imgX + 'px 0px');
                            }, 500);
                            if (window.navigator.geolocation) {
                                window.navigator.geolocation.getCurrentPosition((position) => {
                                    var latlng = new window.google.maps.LatLng(position.coords.latitude, position.coords.longitude);
                                    if (this.locationMarkerRef)
                                        this.locationMarkerRef.setPosition(latlng);
                                    //set marker
                                    mapProps.setCenter(latlng);
                                    clearInterval(animationInterval);
                                    $('#you_location_img').css('background-position', '-144px 0px');
                                });
                            }
                            else {
                                clearInterval(animationInterval);
                                $('#you_location_img').css('background-position', '0px 0px');
                            }
                        });

                        firstChild.index = 1;
                        mapProps.controls[window.google.maps.ControlPosition.RIGHT_BOTTOM].push(firstChild)

                        // standard map stuff
                        this.mapRef = mapProps;
                        this.mapRef.setZoom(11);
                        this.setState({ AgencyData: this.props.ag.getSelectedAgencyData() });
                        this.mapRef.panTo({
                            lat: this.props.ag.getSelectedAgencyLat() == null ? 46.933779 : this.props.ag.getSelectedAgencyLat(),
                            lng: this.props.ag.getSelectedAgencyLat() == null ? -97.238681 : this.props.ag.getSelectedAgencyLong()
                        });

                        oms = new window.OverlappingMarkerSpiderfier(mapProps, {
                            markersWontMove: true,
                            markersWontHide: true,
                            basicFormatEvents: true,
                            keepSpiderfied: true
                        });

                        oms.addListener('click', (m) => {  // 'spider_click', not plain 'click'
                            if (!window.mobileAndTabletcheck()) {
                                m.SpecialClick();
                            }
                        });
                    }}

                    endMarkers={(this.state.showEndMarkers) && endMarkers}
                    startMarkers={startMarkers}
                    tempMarkers={tempMarkers}
                    tempPreviewMarkers={tempPreviewMarkers}

                    backgroundPolyLineRender={backgroundPolyLineRender}
                    backgroundMarkersRender={backgroundMarkersRender}

                    /* Detour Section For Map */
                    DetourPolyLine={<Polyline path={this.detourPath} options={{
                        strokeColor: '#FF5733',
                        strokeOpacity: 0.5,
                        strokeWeight: 10
                    }} />}
                    DetourStart={<div>
                        {this.state.DetourStart !== null && <Marker clickable={false} icon={singlePointIcon} position={this.state.DetourStart} />}
                    </div>
                    }

                    DetourEnd={<div>
                        {this.state.DetourEnd !== null && <Marker clickable={false} icon={startIconSpecial} position={this.state.DetourEnd} />}
                    </div>
                    }
                    detourTempMarkers={detourTempMarkers}

                    detourWaypoints={detourWaypointMarkers}
                    /* Detour Stuffs End */

                    selectedRoute={this.state.selectedRoute && <Polyline path={this.state.polylines}
                        options={{
                            strokeColor: 'black',
                            strokeOpacity: 0.5,
                            strokeWeight: 10
                        }} />}

                    previewPolyLine={<Polyline path={previewPathMap} options={{
                        strokeColor: '#12B3FA',
                        strokeOpacity: 0.5,
                        strokeWeight: 10
                    }} />}

                    tempMarkerRed={<div>
                        {this.state.tempRedMarker !== null && <Marker clickable={false} icon={endIconImg} position={this.state.tempRedMarker} />}
                    </div>
                    }

                    tempGreenMarker={<div>
                        {this.state.tempGreenMarker !== null && <Marker clickable={false} icon={startIcon} position={this.state.tempGreenMarker} />}
                    </div>
                    }

                    waypoints={waypointMarkers}
                    measureTools={<div>
                        {this.state.showMeasureTool && measureTool1}
                        {this.state.showMeasureTool && measureTool2}
                        {this.state.showMeasureTool &&
                            <Polyline path={[this.state.measureLocation1, this.state.measureLocation2]}
                                options={{
                                    strokeColor: '#FEFF3A',
                                    strokeOpacity: 0.7,
                                    strokeWeight: 7
                                }} />}

                    </div>}
                    locationMarker={
                        <div>
                            {this.state.showLocationMarker &&
                                <Marker icon={require('../images/gpsloc.png')} position={{ lat: 0, lng: 0 }} onMarkerInitialized={(markRef) => {
                                    this.locationMarkerRef = markRef
                                }} />}
                        </div>}

                    specialLayer={this.state.specialLayerOn && this.renderSpecialLayer(this.state.specialLayer)}
                />
                {this.state.showCrosshair && this.renderCrosshair()}
            </div>
        );

    }
    popupSnapper = (marker, offset = null) => {
        if (offset === null) {
            offset = { width: 0, height: 0 };
        }

        return (
            <InfoWindow autoPan={false} position={marker.position} options={{ pixelOffset: offset }}>
                <div>
                    <span>Click to snap.</span>
                    <Menu> {/*If not in edit mode this will create a new point for you.*/}
                        <MenuItem iconName="pt-icon-pivot" text="Snap" onClick={() => {

                            if (this.plotMode === PlotStates.startpoint) {
                                this.snapStartTo(marker, false);
                            }

                            else if (this.plotMode === PlotStates.endpoint) {
                                this.snapEndTo(marker);
                            }

                        }} />
                    </Menu>
                </div>
            </InfoWindow>);
    }


    constructionHistorySnappingLayer(data) {
        this.setState({ specialLayerOn: true, specialLayer: data, backgroundPolyLines: [] });
    }
    //#region special layer
    toggleSpecialLayer = (toggleBool) => {
        this.setState({ specialLayerOn: toggleBool });
    }
    // I think that special layer is no longer a thing? Ask to delete. - Elliot 06/04/2021
    renderSpecialLayer(data) {

        const mappedData = data.map((m) => {
            // Don't show anything if CachedRoute is null (Preload Routes)'
            if (m.CachedRoute != null) {
                //const pathMap = convertArrayToLatLng(convertToRouteLatLngArray(m.CachedRoute.points));
                const startPoint = { lat: m.Starting.points[0].x, lng: m.Starting.points[0].y };
                const endPoint = { lat: m.Ending.points[0].x, lng: m.Ending.points[0].y };
                const { RouteId } = m;
                const specialIconSize = { width: 22, height: 22 };
                return (<div key={m.RouteId}>
                    <Marker
                        clickable={this.state.showSnap}
                        icon={{ url: startIconSpecial, scaledSize: specialIconSize }}
                        onMouseOver={() => {
                            if (this.state.showSnap) {
                                this.setState({ popupMarker: RouteId });
                            }
                        }}
                        position={startPoint}>{this.state.showSnap && (this.state.popupMarker === RouteId) && this.popupSnapper({ position: startPoint })}</Marker>

                    <Marker
                        clickable={this.state.showSnap}
                        icon={{ url: startIconSpecial, scaledSize: specialIconSize }}
                        onMouseOver={() => {
                            if (this.state.showSnap) {
                                this.setState({ popupMarker: -RouteId });
                            }
                        }}
                        position={endPoint}>{this.state.showSnap && (this.state.popupMarker === -RouteId) && this.popupSnapper({ position: endPoint })}</Marker>

                </div>);
            }
            return <div></div>
        })

        return <div>{mappedData}</div>
    }
    //#endregion

    onClickDetourStart = (position, snapped, suppressRouteBuild = false) => {
        if (this.plotMode !== PlotStates.startpoint) {
            this.genericShowHideSidePanel(() => {
                this.plotMode = PlotStates.startpoint;
                this.menuControls.isHiding = true;
                this.menuControls.toggleShowData();
                this.setState({ showCrosshair: true, showSnap: true, showEndMarkers: true });
            });
        } else if (this.plotMode === PlotStates.startpoint) {
            // plot a marker here
            let point = {
                key: 0,
                Id: 0,
                position: position,
                value: "Detourtest marker " + 0,
                icon: singlePointIcon
            };
            if (snapped) {
                // callback to update position state.
                this.startDetourCallback(position, snapped);
            }
            else {
                // this allows it to be set back to its original state.
                this.startDetourCallback(position, { snapPoint: -1 });
            }
            this.detourCurrentRoute.detourStartPoint = point;
            //console.log("detour Route Start ",this.detourCurrentRoute.detourStartPoint)
            /* this is an anti-pattern. States are immutable
            * this.state.tempMarkers[point.key] = point;
            * the setState below here fixes it. States can be assigned */
            /*this.setState(prevState => {
                const newTempMarkers = [...prevState.tempMarkers];
                newTempMarkers[point.key] = point;
                return { tempMarkers: newTempMarkers }
            });*/
            this.setState(prevState => {
                const newDetourTempMarkers = [...prevState.detourTempMarkers]
                newDetourTempMarkers[point.key] = point;
                return { detourTempMarkers: newDetourTempMarkers }
            })
            this.menuControls.setState({ showData: true, menuVisible: true });
            this.clearPlotMode();

            if (position.lat) {
                this.mapRef.setZoom(18);
                this.mapRef.panTo(position);
            }
        }
        if (this.plotMode === PlotStates.none) {
            this.clearPlotMode();
        }
        if (suppressRouteBuild) {
            this.isLocationPointMode = true;
            this.detourlineBuild();
        } else {
            this.isLocationPointMode = false;
            this.detourRouteBuild();
        }
    }

    onClickDetourEnd = (position, suppressRouteBuild = false) => {

        if (this.plotMode !== PlotStates.endpoint) {
            this.genericShowHideSidePanel(() => {
                this.plotMode = PlotStates.endpoint;
                this.menuControls.isHiding = true;
                this.menuControls.toggleShowData();
                this.setState({ showCrosshair: true, showSnap: true, showEndMarkers: true });
            });
        } else if (this.plotMode === PlotStates.endpoint) {

            const point = {
                key: 1,
                Id: 1,
                position: position,
                value: "Detourendtest marker " + 1,
                icon: startIconSpecial
            };

            // callback to update position state.
            this.endDetourCallback(position);
            this.detourCurrentRoute.detourEndPoint = point;
            /* this is an anti-pattern. States are immutable
            * this.state.tempMarkers[point.key] = point;
            * the setState below here fixes it. States can be assigned */
            this.setState(prevState => {
                const newDetourTempMarkers = [...prevState.detourTempMarkers]
                newDetourTempMarkers[point.key] = point;
                return { detourTempMarkers: newDetourTempMarkers }
            })
            this.menuControls.setState({ showData: true });
            this.clearPlotMode();

            if (position.lat) {
                this.mapRef.setZoom(18);
                this.mapRef.panTo(position);
            }
        }

        if (this.plotMode === PlotStates.none) {
            this.clearPlotMode();
            this.genericShowHideSidePanel(() => {
                this.menuControls.setState({ showData: true, menuVisible: true });
            });
        }

        if (suppressRouteBuild) {
            this.isLocationPointMode = true;
            this.detourlineBuild();
        } else {
            this.detourRouteBuild();
            this.isLocationPointMode = false;
        }
    }

    onDetourWaypointPlot = (position, id) => {
        if (this.plotMode !== PlotStates.waypoint) {
            this.genericShowHideSidePanel(() => {
                this.plotMode = PlotStates.waypoint;
                this.menuControls.isHiding = true;
                this.menuControls.toggleShowData();
                this.setState({ showCrosshair: true, showSnap: true });
            });

            // cursor for the current waypoint index being modified.
            this.currentDetourWaypointId = id;

        } else if (this.plotMode === PlotStates.waypoint) {
            // plot a marker here
            let point = {
                key: id,
                position: position,
                value: "Detourwaypoint marker " + id,
                icon: waypointIcon
            };
            // callback to updat position state.
            this.startDetourCallback(position, id);
            this.detourCurrentRoute.detourWayPoint[point.key] = {
                location: { lat: position.lat, lng: position.lng }, stopover: true
            };
            /* this is an anti-pattern. States are immutable
            * this.state.waypointMarkers[point.key] = point;
            * the setState below here fixes it. States can be assigned */
            this.setState(prevState => {
                const newDetourWaypointMarkers = [...prevState.detourWaypointMarkers];
                newDetourWaypointMarkers[point.key] = point;
                return { detourWaypointMarkers: newDetourWaypointMarkers }
            });
            /*console.log(this.detourCurrentRoute);
            console.log(this.state.detourWaypointMarkers);
            console.log("waypoint plotted.");*/

            this.menuControls.setState({ showData: true, detourWaypointMarkers: this.state.detourWaypointMarkers });
            this.clearPlotMode();

            if (position.lat) {
                this.mapRef.setZoom(18);
                this.mapRef.panTo(position);
            }
        }
        if (this.plotMode === PlotStates.none) {
            this.clearPlotMode();
        }
        this.detourRouteBuild();
    }






    /*
    * The onclick start position function.
    */
    onClickStart = (position, snapped, suppressRouteBuild = false) => {
        if (this.plotMode !== PlotStates.startpoint) {
            this.genericShowHideSidePanel(() => {
                this.plotMode = PlotStates.startpoint;
                this.menuControls.isHiding = true;
                this.menuControls.toggleShowData();
                this.setState({ showCrosshair: true, showSnap: true, showEndMarkers: true });
            });
        } else if (this.plotMode === PlotStates.startpoint) {
            // plot a marker here
            let point = {
                key: 0,
                Id: 0,
                position: position,
                value: "test marker " + 0,
                icon: startIcon
            };
            if (snapped) {
                // callback to update position state.
                this.startCallback(position, snapped);
            }
            else {
                // this allows it to be set back to its original state.
                this.startCallback(position, { snapPoint: -1 });
            }

            this.currentRoute.startPoint = point;
            /* this is an anti-pattern. States are immutable
            * this.state.tempMarkers[point.key] = point;
            * the setState below here fixes it. States can be assigned */
            this.setState(prevState => {
                const newTempMarkers = [...prevState.tempMarkers];
                newTempMarkers[point.key] = point;
                return { tempMarkers: newTempMarkers }
            });
            this.menuControls.setState({ showData: true, menuVisible: true });
            this.clearPlotMode();

            if (position.lat) {
                this.mapRef.setZoom(18);
                this.mapRef.panTo(position);
            }
        }

        if (this.plotMode === PlotStates.none) {
            this.clearPlotMode();
        }
        if (suppressRouteBuild) {
            this.isLocationPointMode = true;
            this.lineBuild();
        } else {
            this.isLocationPointMode = false;
            this.routeBuild();
        }
    }

    onCheckOverlapping = (start, end) => {
        this.setState({ isCheckOverlap: true, overlapingId: 0, overlapDistance: 0 });
    }

    /*
     * The onclick end position function.
     */
    onClickEnd = (position, suppressRouteBuild = false) => {

        if (this.plotMode !== PlotStates.endpoint) {
            this.genericShowHideSidePanel(() => {
                this.plotMode = PlotStates.endpoint;
                this.menuControls.isHiding = true;
                this.menuControls.toggleShowData();
                this.setState({ showCrosshair: true, showSnap: true, showEndMarkers: true });
            });
        } else if (this.plotMode === PlotStates.endpoint) {

            const point = {
                key: 1,
                Id: 1,
                position: position,
                value: "test marker " + 1,
                icon: endIcon
            };

            // callback to update position state.
            this.endCallback(position);
            this.currentRoute.endPoint = point;
            /* this is an anti-pattern. States are immutable
            * this.state.tempMarkers[point.key] = point;
            * the setState below here fixes it. States can be assigned */
            this.setState(prevState => {
                const newTempMarkers = [...prevState.tempMarkers];
                newTempMarkers[point.key] = point;
                return { tempMarkers: newTempMarkers }
            });
            this.menuControls.setState({ showData: true });
            this.clearPlotMode();

            if (position.lat) {
                this.mapRef.setZoom(18);
                this.mapRef.panTo(position);
            }
        }

        if (this.plotMode === PlotStates.none) {
            this.clearPlotMode();
            this.genericShowHideSidePanel(() => {
                this.menuControls.setState({ showData: true, menuVisible: true });
            });
        }

        if (suppressRouteBuild) {
            this.isLocationPointMode = true;
            this.lineBuild();
        } else {
            this.routeBuild();
            this.isLocationPointMode = false;
        }
    }

    onClickSinglePoint = (position) => {
        //console.log(layer)
        if (this.plotMode !== PlotStates.singlepoint) {
            this.genericShowHideSidePanel(() => {
                this.plotMode = PlotStates.singlepoint;
                this.menuControls.isHiding = true;
                this.menuControls.toggleShowData();
                this.setState({ showCrosshair: true, showSnap: true });
            });

        } else if (this.plotMode === PlotStates.singlepoint) {
            // plot a marker here
            console.log(this.state.currentLayer)
            let marker
            if (this.state.currentLayer === 'Signs')
                marker = startIconPreload
            else
                marker = singlePointIcon

            let point = {
                key: 2,
                Id: 2,
                position: position,
                value: "point marker " + 0,
                icon: marker
            };
            this.menuControls.setState({ showData: true, menuVisible: true });

            // callback to update position state.
            this.startCallback(position);
            this.currentRoute.singlepoint = point;
            /* this is an anti-pattern. States are immutable
            * this.state.tempMarkers[point.key] = point;
            * the setState below here fixes it. States can be assigned */
            this.setState(prevState => {
                const newTempMarkers = [...prevState.tempMarkers];
                newTempMarkers[point.key] = point;
                return { tempMarkers: newTempMarkers }
            });
            this.menuControls.setState({ showData: true });
            this.clearPlotMode();
            if (position.lat) {
                this.mapRef.setZoom(18);
                this.mapRef.panTo(position);
            }
        }
        if (this.plotMode === PlotStates.none) {
            this.clearPlotMode();
        }
    }

    onWaypointPlot = (position, id) => {
        if (this.plotMode !== PlotStates.waypoint) {
            this.genericShowHideSidePanel(() => {
                this.plotMode = PlotStates.waypoint;
                this.menuControls.isHiding = true;
                this.menuControls.toggleShowData();
                this.setState({ showCrosshair: true, showSnap: true });
            });

            // cursor for the current waypoint index being modified.
            this.currentWaypointId = id;

        } else if (this.plotMode === PlotStates.waypoint) {
            // plot a marker here
            let point = {
                key: id,
                position: position,
                value: "waypoint marker " + id,
                icon: waypointIcon
            };

            // callback to updat position state.
            this.startCallback(position, id);
            this.currentRoute.waypoint[point.key] = {
                location: { lat: position.lat, lng: position.lng }, stopover: true
            };
            /* this is an anti-pattern. States are immutable
            * this.state.waypointMarkers[point.key] = point;
            * the setState below here fixes it. States can be assigned */
            this.setState(prevState => {
                const newWaypointMarkers = [...prevState.waypointMarkers];
                newWaypointMarkers[point.key] = point;
                return { waypointMarkers: newWaypointMarkers }
            });
            console.log(this.currentRoute);
            console.log(this.state.waypointMarkers);
            console.log("waypoint plotted.");

            this.menuControls.setState({ showData: true, waypointMarkers: this.state.waypointMarkers });
            this.clearPlotMode();

            if (position.lat) {
                this.mapRef.setZoom(18);
                this.mapRef.panTo(position);
            }
        }
        if (this.plotMode === PlotStates.none) {
            this.clearPlotMode();
        }
        this.routeBuild();
    }

    onWaypointSplice(id) {
        this.state.waypointMarkers.splice(id, 1);
        this.currentRoute.waypoint.splice(id, 1);
        this.routeBuild();
        this.setState({ waypointMarkers: this.state.waypointMarkers });
    }

    onCancelEdit = () => {
        if (window.mobileAndTabletcheck()) {
            this.menuControls.setState({ showData: false, menuVisible: false });
        }
        // clear on markers in progress
        this.setState({
            tempMarkers: [], polylines: [], waypointMarkers: [], selectedMarker: null, DetourPolyLine: [],
            DetourStart: null,
            DetourEnd: null, detourTempMarkers: [], detourTabSelected: 0, detourWaypointMarkers: [],
            overlapingId: 0, overlapDistance: 0
        });

        this.currentRoute = {
            startPoint: null,
            routeLine: null,
            endPoint: null,
            waypoint: []
        };
        this.detourCurrentRoute = {
            detourStartPoint: null,
            detourRouteLine: null,
            detourEndPoint: null,
            detourWayPoint: []
        }

        //get new markers, todo: add refresh? or revert to previously populated list
        //markers = initMarkers;
    }



    onLayerLoaded = (loadedPoints) => {
        //console.log(loadedPoints)
        let newMarkers = [];
        let childMarkers = [];
        let endMarkers = [];

        for (const p of loadedPoints) {
            //let m = newMarkers.length;
            let point = null;

            // Minor Structures and Sign Layer Location Point Table
            if (MainMenu.GetPointBasedLayers().includes(p.LayerId)) {
                if (p.LayerId === 6) {
                    let { Id, SignPoint, LayerId, AgencyId,
                        SignPanelId,
                        LocationNote,
                        SignCategory,
                        PrHigh
                    } = p;

                    let idList = [Id];
                    let markerForSigncategory = null
                    if (SignCategory === 0) {
                        markerForSigncategory = singlePointIcon   // Regulatory Category
                    }
                    else if (SignCategory === 1) {
                        markerForSigncategory = startIconSpecial // Warning Sign
                    }
                    else if (SignCategory === 2) {
                        markerForSigncategory = endIcon // Stop Sign
                    }
                    else if (SignCategory === 3) {
                        markerForSigncategory = startIcon // All Other Signs
                    }
                    else if (SignCategory === 4) {
                        markerForSigncategory = startIconPreload // Newly Saved Sign
                    }

                    point = {
                        key: Id,
                        Id: Id,
                        position: { lat: SignPoint.points[0].x, lng: SignPoint.points[0].y },
                        value: "marker " + Id, // todo: add descripions
                        icon: markerForSigncategory,
                        markerIDs: idList,
                        layerId: LayerId,
                        PrHigh: PrHigh,
                        pointData: {
                            signCategory: SignCategory,
                            agency: AgencyId,
                            point: {
                                id: Id,

                                point: `${SignPoint.points[0].x}, ${SignPoint.points[0].y}`,

                                signPanelId: SignPanelId,
                                locationNote: LocationNote,
                            }
                        }
                    };

                    newMarkers[Id] = (point);
                }
                else if (p.LayerId === 3) {
                    let { Id, Point, LayerId, AgencyId,
                        StructureNumber,
                        PointDescription,
                        InletPoint, OutletPoint,
                        InletElevation, OutletElevation, approachStruct, Updated
                    } = p;
                    let idList = [Id];

                    let markerForMScategory = null
                    if (Updated == false) {
                        markerForMScategory = endIcon //Red

                    }
                    else {
                        markerForMScategory = singlePointIcon //Black
                    }

                    point = {
                        key: Id,
                        Id: Id,
                        position: { lat: Point.points[0].x, lng: Point.points[0].y },
                        value: "marker " + Id, // todo: add descripions
                        icon: markerForMScategory,
                        markerIDs: idList,
                        layerId: LayerId,
                        inletPos: [InletPoint.points[0].x, InletPoint.points[0].y],
                        outletPos: [OutletPoint.points[0].x, OutletPoint.points[0].y],
                        pointData: {
                            agency: AgencyId,
                            point: {
                                id: Id,

                                point: `${Point.points[0].x}, ${Point.points[0].y}`,

                                structureNumber: StructureNumber,
                                pointDescription: PointDescription,

                                inlet: `${InletPoint.points[0].x}, ${InletPoint.points[0].y}`,
                                outlet: `${OutletPoint.points[0].x}, ${OutletPoint.points[0].y}`,

                                inletElevation: InletElevation,
                                outletElevation: OutletElevation,
                                approachStruct: approachStruct
                            }
                        }
                    };

                    newMarkers[Id] = (point);

                }
            }
            else if (p.LayerId === 5) { //VRIC
                // create Virtual Image Capture points
                console.log('generating Virtual Image Capture signs');

                let {
                    Id, LayerId, AgencyId, Position
                } = p;

                let idList = [Id];

                point = {
                    key: Id,
                    Id: Id,
                    position: { lat: Position.points[0].x, lng: Position.points[0].y },
                    value: "marker " + Id, // todo: add descripions
                    icon: singlePointIcon,
                    markerIDs: idList,
                    layerId: LayerId,
                    pointData: {
                        agency: AgencyId,
                        point: {
                            id: Id,
                            point: `${Position.points[0].x}, ${Position.points[0].y}`,
                        }
                    }
                };

                newMarkers[Id] = (point);
            }
            // Route Events Table
            else {
                let { Starting, Ending, Waypoints, CachedRoute, RouteLength,
                    HwyNumber, SegmentDescription, IsPolyLine, DetourCachedRoute, DetourDescription, DetourIsPolyLine, ConsPlanId,
                    DetourWaypoints, EndingDetour, StartingDetour, DetourRouteLength, Type } = p;
                let idList = [];

                if (p.AssociatedRoutes && p.AssociatedRoutes !== "-1") {
                    const tempList = p.AssociatedRoutes.split(',');
                    console.log(tempList);
                    idList = [p.Id].concat(tempList);
                }
                let loadedWaypoints = [];
                if (Waypoints) {
                    loadedWaypoints = convertToRouteLatLngArray(Waypoints.points);
                }

                let detourWaypoints = []
                if (DetourWaypoints) {
                    detourWaypoints = convertToRouteLatLngArray(DetourWaypoints.points)
                }

                let icon = p.LayerId === 4 && Type == 11 ? startIconPreload : startIcon;

                // Caluclate distance
                point = {
                    key: p.Id,
                    Id: p.Id,
                    position: { lat: Starting.points[0].x, lng: Starting.points[0].y },
                    value: "test marker " + p.Id, // todo: add descripions
                    icon: icon,
                    markerIDs: idList,
                    layerId: p.LayerId,
                    pointData: {
                        agency: p.AgencyId,
                        route: {
                            id: p.Id,
                            start: `${Starting.points[0].x}, ${Starting.points[0].y}`,
                            end: `${Ending.points[0].x}, ${Ending.points[0].y}`,
                            routeLength: RouteLength ? RouteLength.toFixed(2) : 0,
                            routeArray: convertToRouteString(CachedRoute.points),
                            routePointArray: convertToRouteLatLngArray(CachedRoute.points),
                            startPoint: convertToRouteLatLngArray(Starting.points),
                            endPoint: convertToRouteLatLngArray(Ending.points),
                            waypoints: loadedWaypoints,
                            isPolyLine: IsPolyLine,
                            hwyNum: HwyNumber === null ? "" : HwyNumber,
                            segDesc: SegmentDescription === null ? "" : SegmentDescription
                        },
                        detourRoute: {
                            detourPosition: StartingDetour === null ? null : { lat: StartingDetour.points[0].x, lng: StartingDetour.points[0].y },
                            consPlanId: ConsPlanId === null ? null : ConsPlanId,
                            DetourrouteLength: DetourRouteLength ? DetourRouteLength.toFixed(2) : 0,
                            DetourIsPolyLine: DetourIsPolyLine === null ? null : DetourIsPolyLine,
                            DetourDescription: DetourDescription === null ? null : DetourDescription,
                            DetourRouteArray: DetourCachedRoute === null ? null : convertToRouteString(DetourCachedRoute.points),
                            DetourRoutePointArray: DetourCachedRoute === null ? null : convertToRouteLatLngArray(DetourCachedRoute.points),
                            DetourstartPoint: StartingDetour === null ? null : convertToRouteLatLngArray(StartingDetour.points),
                            DetourendPoint: EndingDetour === null ? null : convertToRouteLatLngArray(EndingDetour.points),
                            DetourWaypoints: detourWaypoints,
                            DetourStart: StartingDetour === null ? null : `${StartingDetour.points[0].x}, ${StartingDetour.points[0].y}`,
                            DetourEnd: EndingDetour === null ? null : `${EndingDetour.points[0].x}, ${EndingDetour.points[0].y}`
                        }
                    }
                };
                let endPoint = {
                    key: p.Id,
                    Id: p.Id,
                    icon: endIcon,
                    layerId: p.LayerId,
                    position: { lat: Ending.points[0].x, lng: Ending.points[0].y },
                }

                endMarkers[p.Id] = (endPoint);

                if (p.AssociatedRoutes !== "-1") {
                    newMarkers[p.Id] = (point);

                }

                childMarkers[p.Id] = point;
            }
        }

        this.setState({
            markers: newMarkers,
            childMarkers: childMarkers,
            endMarkers: endMarkers
        });
        console.log('State for markers in sign layer ', this.state)

        this.menuControls.refreshLayer();
    }

    onHighlight = (markerData, display) => {
        if (display && markerData) {
            if (markerData.pointData && markerData.pointData.route) {
                this.displayPreviewMarker(markerData);
            }
        }
        else {
            this.onClearTempPoints();
        }

    }

    /* this function gets the list of panels available for a particular support in sign layer when the point is clicked */
    getAvaialablePanels = (signid) => {
        let availablePanelOptions = []
        let optionKey = []
        //const optionvalue = []
        fetch(`${config.server}/getavailablepanels/` + signid)
            .then(response => {
                return response.json();
            })

            .then(data => {
                for (var i = 0; i < data.length; i++) {
                    availablePanelOptions.push(data[i]['OptionCode'])
                    optionKey.push(data[i]['OptionKey'])
                    //optionvalue.push(data[i]['OptionValue'])

                }
                let dropOptions = availablePanelOptions.map((option, idx) => {
                    return { key: optionKey[idx], value: optionKey[idx], label: option, isSelected: false }
                });

                this.setState({
                    availablePanels: dropOptions
                });
            })
            .catch(error => {
                console.log(error);
            });
    }

    /*
     * This function is called when a marker is selected!
     */
    onSelect = (markerId) => {

        this.setDateManagerComp(false);
        this.setStockManagerComp(false);
        console.log(markerId)
        const markerData = this.state.markers[markerId];
        console.log(this.state.markers)
        this.onCancelEdit()
        if (markerData.pointData.route) {
            if (markerData.layerId === 4 && markerData.pointData.detourRoute.DetourstartPoint !== null && markerData.pointData.detourRoute.DetourendPoint !== null) {
                if (markerData.pointData.detourRoute.DetourEnd !== null && markerData.pointData.detourRoute.DetourStart !== null) {
                    let startpoint = {
                        key: 0,
                        Id: 0,
                        position: (markerData.pointData.detourRoute.DetourStart),
                        value: "Starttest marker " + 0,
                        icon: startIcon
                    };
                    let endpoint = {
                        key: 0,
                        Id: 0,
                        position: (markerData.pointData.detourRoute.DetourEnd),
                        value: "Endtest marker " + 0,
                        icon: startIcon
                    };
                    this.detourCurrentRoute.detourEndPoint = endpoint
                    this.detourCurrentRoute.detourStartPoint = startpoint


                }
                if (markerData.pointData.detourRoute.DetourRouteArray !== null)
                    this.displayDetour(markerData.pointData.detourRoute)
            }
            if (markerData.pointData.route.routeLength !== 0) {
                this.displayTempMarker(markerData); //for the data that don't have cachedroute
            }
            const endPoint = markerData.pointData.route.endPoint;
            this.currentRoute.endPoint = {
                position: {
                    lat: endPoint[0][0], lng: endPoint[0][1]
                }
            };
            this.currentRoute.startPoint = { position: markerData.position };
            this.currentRoute.waypoint = [];
            this.setState({ waypointMarkers: [] });

            const loadedWaypoints = markerData.pointData.route.waypoints;

            if (loadedWaypoints) {
                for (var wp of loadedWaypoints) {
                    let index = loadedWaypoints.indexOf(wp);
                    let wpoint = {
                        key: index,
                        position: {
                            lat: wp[0], lng: wp[1]
                        },
                        value: "waypoint marker " + index,
                        icon: waypointIcon
                    };

                    this.currentRoute.waypoint[wpoint.key] = {
                        location: { lat: wp[0], lng: wp[1] }, stopover: true
                    };

                    /* this is an anti-pattern. States are immutable
                    * this.state.waypointMarkers[wpoint.key] = wpoint;
                    * the setState below here fixes it. Because states can be assigned */
                    this.setState(prevState => {
                        const newWaypointMarkers = [...prevState.waypointMarkers];
                        newWaypointMarkers[wpoint.key] = wpoint;
                        return { waypointMarkers: newWaypointMarkers }
                    });
                }

                this.setState({ waypointMarkers: this.state.waypointMarkers });
            }

            this.setState({ selectedMarker: markerData.pointData.route });
        }
        else if (markerData.layerId === 5) {
            // commence selection on the target.
            this.mapRef.setZoom(18);
            this.mapRef.panTo(markerData.position);
            this.getPhotos(markerData.Id)
        }
        else if (markerData.layerId === 6) {
            this.getAvaialablePanels(markerData.Id)
            this.mapRef.setZoom(18);
            this.mapRef.panTo(markerData.position);
            //console.log(markerData)
            let rollbackSignIcon
            if (markerData.pointData.signCategory === 0) {
                rollbackSignIcon = singlePointIcon   // Regulatory Category
            }
            else if (markerData.pointData.signCategory === 1) {
                rollbackSignIcon = startIconSpecial // Warning Sign
            }
            else if (markerData.pointData.signCategory === 2) {
                rollbackSignIcon = endIcon // Stop Sign
            }
            else if (markerData.pointData.signCategory === 3) {
                rollbackSignIcon = startIcon // All Other Signs
            }
            else if (markerData.pointData.signCategory === 4) {
                rollbackSignIcon = startIconPreload // Newly Saved Sign
            }
            if (markerData.pointData.point.point !== '0,0') {
                if (this.state.lastSelectedPoint === null) {
                    this.state.lastSelectedPoint = markerData.Id
                    this.state.markers[markerData.Id].icon = waypointIcon
                }
                else if (this.state.lastSelectedPoint !== null && this.state.lastSelectedPoint !== markerData.Id) {
                    this.state.markers[markerData.Id].icon = waypointIcon;
                    this.state.markers[this.state.lastSelectedPoint] &&
                        (this.state.markers[this.state.lastSelectedPoint].icon = rollbackSignIcon);
                    this.state.lastSelectedPoint = markerData.Id;

                }
                this.mapRef.setZoom(18);
                this.mapRef.panTo(markerData.position);
            }
        }
        else {
            if (markerData.pointData.point.inlet !== '0,0' &&
                markerData.pointData.point.outlet !== '0,0') {
                const intletPoint = {
                    key: 0,
                    Id: 0,
                    position: {
                        lat: markerData.inletPos[0], lng: markerData.inletPos[1]
                    },
                    value: "temp marker " + 0,
                    icon: startIcon
                };

                const outletPoint = {
                    key: 1,
                    Id: 1,
                    position: {
                        lat: markerData.outletPos[0], lng: markerData.outletPos[1]
                    },
                    value: "temp marker " + 1,
                    icon: endIcon
                };

                const tm = [intletPoint, outletPoint];

                this.setState({
                    polylines: convertArrayToLatLng([markerData.inletPos, markerData.outletPos]),
                    tempMarkers: tm
                });
                this.map.fitBounds(googleMapsCreateBounds(convertArrayToLatLng([markerData.inletPos, markerData.outletPos])), gBoundedPadding());//, { paddingTopLeft: boundedPadding() });
            }

            this.mapRef.setZoom(18);
            this.mapRef.panTo(markerData.position);
            //todo draw start/end (idk if this is still to do - Elliot 06/08/2021)
        }


    }
    updateMSMarker = (markerId) => {
        console.log(markerId)
        this.setDateManagerComp(false);
        this.setStockManagerComp(false);
        const markerData = this.state.markers[markerId];
        this.onCancelEdit()
        if (markerData.layerId === 3) {
            this.getAvaialablePanels(markerData.Id)
            this.mapRef.setZoom(18);
            this.mapRef.panTo(markerData.position);
            //console.log(markerData)
            let rollbackSignIcon = singlePointIcon
            this.state.markers[markerId].icon = rollbackSignIcon
            this.mapRef.panTo(markerData.position);
        }

    }

    /*
     * Show end marker and route.
     */
    displayTempMarker = (markerData) => {


        const { endPoint } = markerData.pointData.route;
        const tempTempMarker = [];
        tempTempMarker[1] = {
            key: 1,
            Id: 1,
            position: {
                lat: endPoint[0][0], lng: endPoint[0][1]
            },
            value: "test marker " + 1,
            icon: endIcon
        };
        this.currentRoute.endPoint = tempTempMarker;
        this.currentRoute.startPoint = { position: markerData.position };

        this.triggerPolylineSwitch = (ispoly) => {
            if (ispoly) {
                //todo: optimize so we dont need to calculate route.
                this.setState({
                    tempMarkers: tempTempMarker,
                    polylines: convertArrayToLatLng(createPolyLine(markerData.position, markerData.pointData.route.waypoints, endPoint[0]))
                });
            }
            else {
                this.setState({
                    tempMarkers: tempTempMarker,
                    polylines: convertArrayToLatLng(markerData.pointData.route.routePointArray)
                });
            }
        }

        this.triggerPolylineSwitch(markerData.pointData.route.isPolyLine);
        this.map.fitBounds(googleMapsCreateBounds(convertArrayToLatLng(markerData.pointData.route.routePointArray)), gBoundedPadding());//, { paddingTopLeft: boundedPadding() });
    }

    /* Display detour route on Construction Planning Route Selected */
    displayDetour = (markerData) => {
        const { DetourendPoint, DetourstartPoint, DetourIsPolyLine, detourPosition, DetourWaypoints, DetourRoutePointArray } = markerData
        let tempDetourPolyLine = null

        if (DetourIsPolyLine) {
            tempDetourPolyLine = createPolyLine(detourPosition, DetourWaypoints, DetourendPoint[0])
        }
        else {
            tempDetourPolyLine = DetourRoutePointArray
        }
        const detourWayPoints = DetourWaypoints
        if (detourWayPoints) {
            for (var wp of detourWayPoints) {
                let index = detourWayPoints.indexOf(wp);
                let wpoint = {
                    key: index,
                    position: {
                        lat: wp[0], lng: wp[1]
                    },
                    value: "waypoint marker " + index,
                    icon: waypointIcon
                };

                this.detourCurrentRoute.detourWayPoint[wpoint.key] = {
                    location: { lat: wp[0], lng: wp[1] }, stopover: true
                };

                /* this is an anti-pattern. States are immutable
                * this.state.waypointMarkers[wpoint.key] = wpoint;
                * the setState below here fixes it. Because states can be assigned */
                this.setState(prevState => {
                    const newWaypointMarkers = [...prevState.detourWaypointMarkers];
                    newWaypointMarkers[wpoint.key] = wpoint;
                    return { detourWaypointMarkers: newWaypointMarkers }
                });
            }

            // this.setState({  });
        }
        this.setState({
            DetourPolyLine: tempDetourPolyLine,
            DetourStart: { lat: DetourstartPoint[0][0], lng: DetourstartPoint[0][1] },
            DetourEnd: {
                lat: DetourendPoint[0][0], lng: DetourendPoint[0][1],
                detourWaypointMarkers: this.state.detourWaypointMarkers
            }
        })
    }


    displayPreviewMarker = (markerData) => {

        const { endPoint } = markerData.pointData.route;
        let tempPolyLine = null;
        if (markerData.pointData.route.isPolyLine) {
            tempPolyLine = createPolyLine(markerData.position, markerData.pointData.route.waypoints, endPoint[0]);
        }
        else {
            tempPolyLine = markerData.pointData.route.routePointArray;
        }

        this.setState({ previewPolyline: tempPolyLine, tempRedMarker: { lat: endPoint[0][0], lng: endPoint[0][1] } });
    }

    displaySinglePreviewMarker = (markerData) => {
        const { inletPos, outletPos, pointData } = markerData;

        this.setState({
            previewPolyline: [inletPos, outletPos]
        });

        if (pointData.point.inlet !== '0,0' && pointData.point.outlet !== '0,0') {
            this.setState({
                tempGreenMarker: {
                    lat: inletPos[0], lng: inletPos[1]
                },

                tempRedMarker: {
                    lat: outletPos[0], lng: outletPos[1]
                }
            });
        }
    }

    onClearMap = () => {
        // Older slower method.
        this.setState({
            markers: [],
            tempMarkers: [],
            polylines: [],
            detailsPolylines: [],
            selectedMarker: null
        });

        // New methods faster, and better.
        this.onClearTempPoints();
    }


    onClearTempPoints = () => {

        this.setState({
            previewPolyline: [], tempRedMarker: null, tempGreenMarker: null
        });
    }

    clearStartWhenAddedPoint = () => {
        let m = [];
        m[1] = this.state.tempMarkers[1];
        this.setState({ tempMarkers: m });
    }

    clearPlotMode = () => {
        this.setState({ showCrosshair: false, showSnap: false, showEndMarkers: false, popupMarker: 0 });
        this.plotMode = PlotStates.none;
    }

    genericShowHideSidePanel = (callback) => {
        callback();
    }

    updateVRICPhotoList = (list) => {
        var tmp = JSON.parse(JSON.stringify(this.state.VRICPhotos))
        tmp.photos = list;
        this.setState({ VRICPhotos: tmp })
    }

    /*detourlineBuild = () => {
        console.log(this.detourCurrentRoute)
        if (this.detourCurrentRoute.detourStartPoint !== null && this.detourCurrentRoute.detourEndPoint !== null) {
            const startPosition = this.detourCurrentRoute.detourStartPoint.position;
            const endPosition = this.detourCurrentRoute.detourEndPoint.position;
            this.setState({ DetourPolyLine: convertArrayToLatLng([startPosition, endPosition]) });
        }
    }*/

    detourRouteBuild = () => {
        let isPolyLine = false;
        /*if (this.state.selectedMarker.isPolyLine && this.currentRoute.startPoint !== null && this.currentRoute.endPoint !== null) {
             // Convert cached route to polyline explicitly!
             this.setState({
                 DetourPolyLine: convertArrayToLatLng(createPolyLineStd(this.state.selectedMarker.startPoint[0], this.state.selectedMarker.waypoints, this.state.selectedMarker.endPoint[0]))
             });
 
             isPolyLine = true;
         }*/

        if (this.detourCurrentRoute.detourStartPoint !== null && this.detourCurrentRoute.detourEndPoint !== null && !isPolyLine) {
            const gmaps = window.google.maps;
            const startPosition = this.detourCurrentRoute.detourStartPoint.position;
            const endPosition = this.detourCurrentRoute.detourEndPoint.position;
            var directionsService = new gmaps.DirectionsService();
            //https://developers.google.com/maps/documentation/javascript/directions
            directionsService.route({
                origin: startPosition,
                destination: endPosition,
                waypoints: this.detourCurrentRoute.detourWayPoint,
                travelMode: 'DRIVING'
            },
                (response, status) => {
                    // Route the directions and pass the response to a function to create
                    // markers for each step.
                    if (status === 'OK') {
                        let decoded = decodeRouteData(response);
                        this.detourCurrentRoute.detourRouteLine = decoded;
                        this.setState({ DetourPolyLine: decoded.decodedString });

                    } else {
                        console.log('Directions request failed due to ' + status);
                    }
                }
            );
        }
    }

    /*
     * builds the route line
     */
    routeBuild = () => {
        let isPolyLine = false;
        console.log('Hello here', this.state.selectedMarker)
        if (this.state.selectedMarker && this.state.selectedMarker.isPolyLine && this.currentRoute.startPoint !== null && this.currentRoute.endPoint !== null) {
            // Convert cached route to polyline explicitly!
            this.setState({
                polylines: convertArrayToLatLng(createPolyLineStd(this.state.selectedMarker.startPoint[0], this.state.selectedMarker.waypoints, this.state.selectedMarker.endPoint[0]))
            });

            isPolyLine = true;
            if (this.state.isCheckOverlap) {
                this.setState({ isCheckOverlap: false });
                this.getOverlapping();
            }
        }

        if (this.currentRoute.startPoint !== null && this.currentRoute.endPoint !== null && !isPolyLine) {
            const gmaps = window.google.maps;
            const startPosition = this.currentRoute.startPoint.position;
            const endPosition = this.currentRoute.endPoint.position;
            var directionsService = new gmaps.DirectionsService();
            //https://developers.google.com/maps/documentation/javascript/directions
            directionsService.route({
                origin: startPosition,
                destination: endPosition,
                waypoints: this.currentRoute.waypoint,
                travelMode: 'DRIVING'
            },
                (response, status) => {
                    // Route the directions and pass the response to a function to create
                    // markers for each step.
                    if (status === 'OK') {
                        let decoded = decodeRouteData(response);
                        this.currentRoute.routeLine = decoded;
                        this.setState({ polylines: convertArrayToLatLng(decoded.decodedString), detailsPolylines: [] });
                        if (this.state.isCheckOverlap) {
                            let decodedDetails = decodeDetailedRouteData(response);
                            this.setState({ detailsPolylines: convertArrayToLatLng(decodedDetails.decodedString), isCheckOverlap: false });
                            this.getOverlapping();
                        }
                    } else {
                        console.log('Directions request failed due to ' + status);
                    }
                }
            );
        }
    }

    getOverlapping = (id) => {
        let value = this.state;
        let lines = value.detailsPolylines && value.detailsPolylines.length > 0 ? value.detailsPolylines :
            value.polylines && value.polylines.length > 0 ? value.polylines : [];
        let points = lines.length > 0 ? convertLatLngToArray(lines).join(' ') : '';

        let finalData = {
            agencyId: value.AgencyData && value.AgencyData.id ? value.AgencyData.id : 0,
            routeId: value.selectedMarker && value.selectedMarker.id ? value.selectedMarker.id : 0,
            points: points
        };

        console.log(finalData)
        $.ajax({
            type: 'POST',
            url: `${config.server}\\getoverlappingroute`,
            contentType: 'application/json',
            data: JSON.stringify(finalData),

            success: (data) => {
                if (data['Message'] === "success" && data['Id'] > 0) {
                    this.setState({ overlapingId: data['Id'], overlapDistance: data['Distance'] });
                    let message = 'The segment entered overlaps an existing segment. Please cancel the new segment and modify the existing segment start or end location to avoid overlapping. Or modify the attributes of the new segment if this is an overlay or maintenance work.';
                    alert(message);
                }
            },
        });
    }

    lineBuild = () => {
        if (this.currentRoute.startPoint !== null && this.currentRoute.endPoint !== null) {
            const startPosition = this.currentRoute.startPoint.position;
            const endPosition = this.currentRoute.endPoint.position;

            this.setState({ polylines: convertArrayToLatLng([startPosition, endPosition]) });
        }
    }

    snapStartTo = (marker, snapStartPoint = true) => {
        if (this.state.currentLayer === 'ConstructionPlanning') {
            this.hideBackgroundLayer();
        }
        this.plotMode = PlotStates.startpoint;

        // Becareful with this snapping mechanism. Attaching a child to the end marker does wierd stuff.
        if (snapStartPoint) {
            this.onClickStart(marker.position); // ignore the special marker logic.
            if (this.state.detourTabSelected === 4) {
                this.onClickDetourStart(marker.position)
            }
        }
        else {
            if (this.state.detourTabSelected === 4) {
                this.onClickDetourStart(marker.position)
            }
            this.onClickStart(marker.position);

        }
    }

    /*snapDetourStartTo = (marker, snapStartPoint = true) => {
        if (this.state.currentLayer === 'ConstructionPlanning') {
            this.hideBackgroundLayer();
        }
        this.plotMode = PlotStates.startpoint;

        // Becareful with this snapping mechanism. Attaching a child to the end marker does wierd stuff.
        if (snapStartPoint) {
            this.onClickDetourStart(marker.position); // ignore the special marker logic.
        }
        else {
            this.onClickDetourStart(marker.position);
        }
    }*/

    snapEndTo = (marker) => {
        if (this.state.currentLayer === 'ConstructionPlanning') {
            this.hideBackgroundLayer();
        }
        this.plotMode = PlotStates.endpoint;
        if (this.state.detourTabSelected === 4) {
            this.onClickDetourEnd(marker.position)
        }
        this.onClickEnd(marker.position);

    }

    showHideMeasureTool = (show, sp) => {
        this.setState({
            showMeasureTool: show,
            measureLocation1: sp,
            measureLocation2: sp
        });
    }

    /*
     * First measurement node.
     */
    updateMeasureLocation1 = (target) => {

        let m1 = {
            lat: target.latLng.lat(), lng: target.latLng.lng()
        };
        let m2 = this.state.measureLocation2;
        this.measureDistance = distance(m1.lat, m1.lng, m2.lat, m2.lng);
        this.setState({
            measureLocation1: m1,
            measureLocation2: m2
        });

    }

    /*
     * Second measurement node.
     */
    updateMeasureLocation2 = (target) => {
        let m1 = this.state.measureLocation1;
        let m2 = {
            lat: target.latLng.lat(), lng: target.latLng.lng()
        };
        this.measureDistance = distance(m1.lat, m1.lng, m2.lat, m2.lng);
        this.setState({
            measureLocation1: m1,
            measureLocation2: m2
        });
    }

    mapTempMarkers = (marker) => {
        if (marker) {
            const { key, position, icon } = marker;
            return (<Marker key={key} position={position}
                icon={{ url: icon }}
                onClick={this.onClickMarker}></Marker>);
        }
    }

    mapdetourTempMarkers = (marker) => {
        if (marker) {
            const { key, position, icon } = marker;
            return (
                <Marker key={key} position={position}
                    icon={{ url: icon }}
                    onClick={this.onClickMarker}></Marker>
            );
        }
    }

    hideBackgroundLayer = () => {
        this.onBackgroundLayerChange([]);
        this.onToggleSpecialLayer(false);
        this.setState({ shouldHideCPLegend: true });
    }

    renderCrosshair = () => {
        let onclickPoint = <div></div>;
        // start/end points
        if (this.plotMode === PlotStates.startpoint) {
            onclickPoint = <button type="button"
                className="centerButton pt-button pt-icon-arrow-down pt-intent-success"
                onClick={() => {
                    if (this.state.currentLayer === "ConstructionPlanning") {
                        this.hideBackgroundLayer();
                    }
                    if (this.state.detourTabSelected === 4) {
                        this.onClickDetourStart(convertMapCenter(this.map.getCenter()), null, this.isLocationPointMode);
                    }
                    else if (this.state.detourTabSelected !== 4) {
                        this.onClickStart(convertMapCenter(this.map.getCenter()), null, this.isLocationPointMode);
                    }
                }} ></button>;
        }
        else if (this.plotMode === PlotStates.endpoint) {
            onclickPoint = <button type="button"
                className="centerButton pt-button pt-icon-arrow-down pt-intent-warning"
                onClick={() => {
                    if (this.state.currentLayer === "ConstructionPlanning") {
                        this.hideBackgroundLayer();
                    }
                    if (this.state.detourTabSelected === 4) {
                        this.onClickDetourEnd(convertMapCenter(this.map.getCenter()), null, this.isLocationPointMode);
                    }
                    else if (this.state.detourTabSelected !== 4) {
                        this.onClickEnd(convertMapCenter(this.map.getCenter()), this.isLocationPointMode);
                    }

                }}></button>;
        }
        // location points
        else if (this.plotMode === PlotStates.singlepoint) {
            onclickPoint = <button type="button"
                className="centerButton pt-button pt-icon-arrow-down pt-intent-primary"
                onClick={() => { this.onClickSinglePoint(convertMapCenter(this.map.getCenter())); }}></button>;
        }
        else if (this.plotMode === PlotStates.waypoint && this.state.detourTabSelected === 4) {
            onclickPoint = <button type="button"
                className="centerButton pt-button pt-icon-arrow-down pt-intent-primary"
                onClick={() => { this.onDetourWaypointPlot(convertMapCenter(this.map.getCenter()), this.currentDetourWaypointId); }}></button>;
        }

        else if (this.plotMode === PlotStates.waypoint && this.state.detourTabSelected !== 4) {
            onclickPoint = <button type="button"
                className="centerButton pt-button pt-icon-arrow-down pt-intent-primary"
                onClick={() => { this.onWaypointPlot(convertMapCenter(this.map.getCenter()), this.currentWaypointId); }}></button>;
        }
        return <div className="centerMarker_Yellow">{onclickPoint}</div>;
    }

    getPhotos = (id) => {
        // Get the photos related to this VRIC point
        $.ajax({
            type: 'GET',
            url: `${config.server}\\getVRICPhotos\\${id}`,
            contentType: 'application/json',
            success: (data) => {
                data.photos.forEach(photo => {
                    // parse the collectiondatetime
                    var dateTimeStr = photo['CollectionDateTime']
                    var dateTime = new Date(Date.parse(dateTimeStr))

                    // To locale string doesn't work for me :(, manual conversion from UTC time
                    dateTime.setHours(dateTime.getHours() + 5)
                    photo['CollectionDateTime'] = dateTime
                })
                this.setState({ VRICPhotos: data });
            },
        });
    }



    setDateManagerComp = (bools) => { this.setState({ dateManagerComp: bools }) }

    setStockManagerComp = (bools) => { this.setState({ stockManagerComp: bools }) }

}



// WEBPACK FOOTER //
// ./src/maps/map-googlemap.js